import { Box, Card, CardHeader, CardHeaderTypeMap } from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { BaseApplicationState } from 'state/baseapplication/Reducer';

// eslint-disable-next-line @typescript-eslint/ban-types
type CardMember = OverridableComponent<CardHeaderTypeMap<{}, 'div'>>;

const CardEmployeeManage: CardMember = CardHeader;

const RiskManagementCard: React.FC<any> = () => {
  const navigate = useNavigate();
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  return (
    <Box className="employee-management-wrapper">
      <Card variant="outlined">
        <CardHeader title="Risk Management" />
        <CardEmployeeManage
          title="Risk Assessment Templates"
          subheader="Manage and create risk assessment templates"
          action={
            orgACLConfig.settings?.includes(
              'settings.management.manageAssessmentTemplates'
            ) && (
              <AppPrimaryButton
                title="Manage Assessment Templates"
                sx={{ background: '#06362b !important' }}
                onClick={() => {
                  navigate('/assessment-templates');
                }}
              />
            )
          }
        />
      </Card>
    </Box>
  );
};

export default RiskManagementCard;
